import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { BoxModelInput } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/BoxModelField/BoxModelInput";

export const Margin = () => (
  <EditorCollapsable
    title={t("builder_ui.prop_type.styles.margin")}
    defaultOpen
  >
    <div className="flex flex-col px-6 py-4">
      <BoxModelInput
        type="margin"
        name="styles.margin"
        label={t("builder_ui.prop_type.styles.margin")}
      />
    </div>
  </EditorCollapsable>
);
